/**
 * @fileoverview POST handler for the "/apps/:app_group_id/event_properties_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdEventPropertiesSettingsCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdEventPropertiesSettingsProps,
  AppsAppGroupIdEventPropertiesSettingsResult,
} from "./types";

export const postAppsAppGroupIdEventPropertiesSettings = reactQueryMutationAdapter(
  appsAppGroupIdEventPropertiesSettingsCacheKeys,
  (props: PostAppsAppGroupIdEventPropertiesSettingsProps): Promise<AppsAppGroupIdEventPropertiesSettingsResult> => {
    const { appGroupId, ...request } = props;
    return fetch(`/apps/${appGroupId}/event_properties_settings`, "POST", request);
  }
);
